<template>
  <v-container
    id="login"
    fill-height
    tag="section"
  >
    <v-snackbar xs12
      v-model="snackbar"
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>  
    <v-row justify="center">
      <v-form
        ref="form"
        v-model="valid"
        >


      <v-slide-y-transition appear>
        <base-material-card
          color="success"
          light
          max-width="100%"
          width="300"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-6">
                Reset Paythings Password
              </h1>
            </div>
          </template>
          <v-card-text class="text-center">
            <div class="text-center black--text body-1 font-weight-light">
              Please enter in the email address used on the account. You will receive and email with a link to reset the password.
            </div>
            <v-text-field
              color="secondary"
              label="Email..."
              v-model="email"
              :rules="emailRules"
              prepend-icon="mdi-email"
            />

          </v-card-text>
            <v-card-actions class="justify-center">
              <v-row class="d-flex justify-center" >
            <pages-btn 
              :disabled="!valid"
              @click="submit"
              color="success"
              
              >
              Reset
            </pages-btn> 
             <pages-btn 
              text
              color="info"
              to="/pages/register"
              >
              Register New Account
              </pages-btn>
             <pages-btn 
              text
              color="info"
              to="/pages/login"
              >
              Sign In
              </pages-btn>               
              </v-row>

 
            </v-card-actions>
        </base-material-card>
      </v-slide-y-transition>
      </v-form>
    </v-row>

  </v-container>
</template>

<script>
  export default {
    name: 'PagesLogin',

    components: {
      PagesBtn: () => import('./components/Btn')
    },

    data: () => ({
      snackbar: false,
      multiLine: true,     
      timeout: 3000,
      alertmessage: "",
      valid: true,
      password: '',
      passwordrules : [
        v => !!v || 'Passowrd is required'
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      socials: [
        {
          href: '#',
          icon: 'mdi-facebook-box'
        },
        {
          href: '#',
          icon: 'mdi-twitter'
        },
        {
          href: '#',
          icon: 'mdi-github-box'
        }
      ]
    }),
    computed: {
      user () {
        return this.$store.getters.user
      },
      error () {
        return this.$store.getters.error
      },
      loading () {
        return this.$store.getters.loading
      },
    },
    watch: {
      user (value) {
        if (value !== null && value !== undefined) {
          this.$router.push('/')
        }
      },
    },
    methods: {
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      closesnack () {
      },
      submit () {
        this.alertmessage = 'Password reset mail has been sent'
        this.$store.dispatch('sendpassreset',this.email)
        this.$refs.form.reset()
        this.snackbar = true

      }
    }
  }
</script>
